import { Helmet } from "react-helmet-async";

const BASE = "https://www.scuoladidatticasicura.it";

export default function Seo({ title, description, path = "", image = "/images/hero.jpg" }) {
  const url = `${BASE}${path}`;
  const img = image.startsWith("http") ? image : `${BASE}${image}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="it_IT" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
